<!-- Widget -->
<script lang="ts">
	import isPhoneSize from '../helpers/IsPhoneSize';
	export let src: string;
	export let isPopup: boolean;
	export let height: number;
	export let isWidgetOpened: boolean;

	let fullVerticalHeight: number = window.innerHeight;
	// Computed vertical height for mobile
	window.addEventListener('resize', () => {
		fullVerticalHeight = window.innerHeight;
	});

	$: maxHeight = () => {
		if (isPhoneSize() || isPopup || !isWidgetOpened) {
			return `${fullVerticalHeight}px`;
		} else {
			return `${fullVerticalHeight - 165}px`;
		}
	};
</script>

<div
	id="surveybot_widget_container"
	class="widget-wrap-f31sa"
	class:--popup={isPopup}
	class:--widget-opened={isWidgetOpened}
	frameborder="0"
	style="
		height: {isWidgetOpened ? `${fullVerticalHeight}px` : `${height}px`};
		max-height: {maxHeight()}
	"
>
	<iframe
		id="surveybot_widget_iframe"
		class="iframe-f31sa"
		{src}
		frameborder="0"
		allow="geolocation"
		allowfullscreen
		title="widget"
	/>
</div>

<style>
	.widget-wrap-f31sa {
		width: 368px;
		z-index: 205999;
		position: fixed;
		right: 16px;
		bottom: 16px;
	}

	.iframe-f31sa {
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}

	/* Widget as popup */
	.--popup {
		width: 100vw !important;
		max-width: 100vw;
		height: 100vh !important;
		right: 0;
		bottom: 0 !important;
		background-color: rgba(0, 0, 0, 0.24);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.--popup > .iframe-f31sa {
		max-width: 800px;
		max-height: 560px;
	}

	.--widget-opened {
		bottom: 112px;
	}

	@media screen and (max-width: 450px) {
		.widget-wrap-f31sa {
			width: 90vw;
		}

		.--widget-opened {
			width: 100vw;
			height: 100vh;
			right: 0;
			bottom: 0;
		}
	}
</style>
